import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=6007ab38&lang=pug&"
import script from "./Box.vue?vue&type=script&lang=js&"
export * from "./Box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6007ab38', component.options)
    } else {
      api.reload('6007ab38', component.options)
    }
    module.hot.accept("./Box.vue?vue&type=template&id=6007ab38&lang=pug&", function () {
      api.rerender('6007ab38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/preview_area/built-in component/Box.vue"
export default component.exports